/*
 * Copyright (c) 2018, Lolol.com  All rights reserved.
 */
import styled from "styled-components";
import Color from "../assets/Color";

/*
  1.  GENERAL
  2.  FORM
      2.1 Input
  3.  BUTTON
  4.  TABLE
  5.  SPINNER
*/

const DumpsterStyle = styled.div`
  /* ====== 1.  GENERAL ===== */
  .full-width {
    width: 100%;
  }
  p {
    word-break: break-word;
  }
  .text-left {
    text-align: left !important;
  }

  .text-right {
    text-align: right !important;
  }

  .text-center {
    text-align: center !important;
  }
  /* ====== END 1.  GENERAL ===== */

  /* ====== 2.  FORM ===== */
  //** FORM LABEL
  .ant-form .ant-form-item-label label {
    margin-bottom: 8px;
    text-transform: uppercase;
    color: #949494;
  }

  /* ====== 2.1 Input ===== */
  //** INPUT HOVER
  .ant-input-search:hover,
  .ant-input:focus,
  .ant-input:hover,
  .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),
  .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: ${Color.Secondary};
  }

  //** INPUT FOCUS
  .ant-input:focus {
    box-shadow: 0 0 0 2px rgba(255, 237, 223, 0.2);
  }

  //INPUT GROUP DROPDOWN
  // **INPUT GROUP DROPDOWN HOVER
  .ant-input-group.ant-input-group-compact
    > .ant-select
    > .ant-select-selection:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-calendar-picker
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-select-auto-complete
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-mention-wrapper
    .ant-mention-editor:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-time-picker
    .ant-time-picker-input:hover {
    border-color: ${Color.Secondary};
  }

  .ant-input-group.ant-input-group-compact > *:last-child:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-select:last-child
    > .ant-select-selection:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-calendar-picker:last-child
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-select-auto-complete:last-child
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker:last-child
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker-focused:last-child
    .ant-input:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-mention-wrapper:last-child
    .ant-mention-editor:hover,
  .ant-input-group.ant-input-group-compact
    > .ant-time-picker:last-child
    .ant-time-picker-input:hover {
    border-color: ${Color.Secondary};
  }

  //**INPUT GROUP DROPDOWN FOCUS
  .ant-input-group.ant-input-group-compact
    > .ant-select
    > .ant-select-selection:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-calendar-picker
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-select-auto-complete
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-mention-wrapper
    .ant-mention-editor:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-time-picker
    .ant-time-picker-input:focus {
    border-color: ${Color.Secondary};
    box-shadow: 0 0 0 2px rgba(255, 237, 223, 0.2);
  }

  .ant-input-group.ant-input-group-compact > *:last-child:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-select:last-child
    > .ant-select-selection:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-calendar-picker:last-child
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-select-auto-complete:last-child
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker:last-child
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-cascader-picker-focused:last-child
    .ant-input:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-mention-wrapper:last-child
    .ant-mention-editor:focus,
  .ant-input-group.ant-input-group-compact
    > .ant-time-picker:last-child
    .ant-time-picker-input:focus {
    border-color: ${Color.Secondary};
    box-shadow: 0 0 0 2px rgba(255, 237, 223, 0.2);
  }
  /* ====== END 2.1 Input ===== */
  /* ====== END 2.  FORM ===== */

  // TABS
  .ant-tabs .ant-tabs-content {
    margin-top: 0px;
  }

  .ant-tabs .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab-active,
  .ant-tabs .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab:hover {
    color: ${Color.Secondary};
  }

  /* ====== 3.  BUTTON ===== */
  button[type="button"].ant-btn {
    text-transform: uppercase;
    font-weight: 400;

    //SMALL BUTTON
    &.ant-btn-sm {
      height: 30px;
      line-height: 1;
    }
  }
  .button-group {
    button {
      margin-left: 8px;
    }
  }
  /* ====== END 3.  BUTTON ===== */

  /* ====== 4.  TABLE ===== */

  // PAGINATION
  .ant-pagination .ant-pagination-item-active:focus,
  .ant-pagination .ant-pagination-item-active:focus a {
    border-color: ${Color.PaleOrange};
    color: ${Color.white};
  }

  .ant-pagination .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next:hover .ant-pagination-item-link,
  .ant-pagination .ant-pagination-prev,
  .ant-pagination-next {
    border-color: ${Color.Secondary};
    border: 1px solid ${Color.Secondary};
  }
  .ant-pagination .ant-pagination-item-link:hover {
    color: ${Color.Secondary};
    border-color: ${Color.Secondary};
  }

  .table-filter-container {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .table-btn-filter {
    margin-right: 10px;
  }
  .table-search-box {
    width: 200px;
  }
  .table-refresh-button {
    cursor: pointer;
    font-size: 25px;
    margin-left: 10px;
  }
  /* ====== END 4.  TABLE ===== */

  /* ====== 5.  SPINNER ===== */
  .ant-spin-dot i {
    background-color: ${Color.Secondary};
  }
  /* ====== END 5.  SPINNER ===== */
`;

export default DumpsterStyle;
